/**
 * MIRAK video sound: shared click-to-play + mute/unmute behavior for video
 * tiles that use the "play with sound" mode (MIRAK Showcase, MIRAK Media
 * Grid). Browsers block autoplay-with-sound, so a video in this mode starts
 * paused on a poster frame; the first play() call happens from a real click,
 * which is allowed to start unmuted. Once playing, a small mute button lets
 * the visitor toggle sound without restarting playback.
 */

function initVideoSound(wrapper) {
  const video = wrapper.querySelector('video');
  if (!video) return;

  const playButton = wrapper.querySelector('[data-mirak-video-play]');
  const muteButton = wrapper.querySelector('[data-mirak-video-mute]');

  const play = () => {
    video.muted = false;
    video.play().catch(() => {});
  };

  playButton?.addEventListener('click', (event) => {
    event.preventDefault();
    play();
  });

  video.addEventListener('click', () => {
    if (video.paused) play();
  });

  video.addEventListener('play', () => {
    wrapper.classList.add('is-playing');
    if (muteButton) muteButton.hidden = false;
  });

  video.addEventListener('pause', () => {
    wrapper.classList.remove('is-playing');
  });

  muteButton?.addEventListener('click', (event) => {
    event.preventDefault();
    video.muted = !video.muted;
    muteButton.setAttribute('aria-pressed', String(video.muted));
  });

  // Force-stop if the tile scrolls out of view, so a video a visitor
  // started playing doesn't keep running (and making noise) off-screen.
  const visibilityObserver = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting && !video.paused) video.pause();
      });
    },
    { threshold: 0 },
  );
  visibilityObserver.observe(wrapper);
}

document.querySelectorAll('[data-mirak-video-sound]').forEach(initVideoSound);
